import type { NavigationGroup } from "@intelligems/ig-clients/storefront-navigation/navigation-items";

export const GROUP_LABELS: Record<NavigationGroup, string> = {
  pages: "Pages",
  collections: "Collections",
  products: "Products",
  articles: "Blog Posts",
};

/** The time the Navigator waits after the last keystroke before it searches. */
export const NAVIGATOR_INPUT_DEBOUNCE_MS = 300;
